import React from 'react';

const PackageDetailView = ({ state }) => {
  const {
    selectedPackage,
    setSelectedPackage,
    setActiveView,
    setPackages,
    setNotification,
  } = state;

  const pkg = selectedPackage;
  if (!pkg) return null;

  const sendPackageToCSA = () => {
    setNotification(`Package "${pkg.name}" with ${pkg.briefs.length} briefs sent to Content Scaling Agent via SEO API.`);
    setPackages(prev => prev.map(p =>
      p.id === pkg.id ? { ...p, status: 'delivered' } : p
    ));
    setSelectedPackage(null);
    setActiveView('dashboard');
  };

  const exportPackage = () => {
    setNotification(`Package "${pkg.name}" exported as deliverable for content team.`);
  };

  const removeBriefFromPackage = (briefId) => {
    setPackages(prev => prev.map(p =>
      p.id === pkg.id
        ? { ...p, briefs: p.briefs.filter(b => b.id !== briefId) }
        : p
    ));
    setSelectedPackage(prev => ({
      ...prev,
      briefs: prev.briefs.filter(b => b.id !== briefId)
    }));
  };

  return (
    <div style={{ padding: '32px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 24 }}>
        <div>
          <button
            onClick={() => {
              setSelectedPackage(null);
              setActiveView('dashboard');
            }}
            style={{
              background: 'none',
              border: 'none',
              color: '#6b7280',
              fontSize: 13,
              cursor: 'pointer',
              padding: 0,
              marginBottom: 8,
              display: 'flex',
              alignItems: 'center',
              gap: 4
            }}
          >
            {'\u2190'} Back to Dashboard
          </button>
          <h2 style={{ margin: '0 0 8px', fontSize: 24, fontWeight: '600', color: '#f3f4f6' }}>{pkg.name}</h2>
          <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
            <span style={{ fontSize: 14, color: '#9ca3af' }}>Macro Trend: <strong style={{ color: '#f3f4f6' }}>{pkg.macroTrend}</strong></span>
            <div style={{ display: 'flex', gap: 6 }}>
              {pkg.categories.map((cat, idx) => (
                <span key={idx} style={{
                  padding: '4px 10px',
                  backgroundColor: '#3b82f620',
                  border: '1px solid #3b82f6',
                  borderRadius: 4,
                  fontSize: 11,
                  color: '#93c5fd'
                }}>
                  {cat}
                </span>
              ))}
            </div>
          </div>
        </div>
        <div style={{
          padding: '6px 14px',
          backgroundColor: '#8b5cf620',
          borderRadius: 6,
          fontSize: 12,
          color: '#a78bfa',
          fontWeight: '500'
        }}>
          {pkg.briefs.length} Brief{pkg.briefs.length !== 1 ? 's' : ''} in Package
        </div>
      </div>

      {/* Briefs in Package */}
      <div style={{ marginBottom: 32 }}>
        <h3 style={{ margin: '0 0 16px', fontSize: 16, fontWeight: '600', color: '#f3f4f6' }}>Briefs</h3>
        {pkg.briefs.length === 0 ? (
          <div style={{
            padding: 40,
            backgroundColor: '#1e1e32',
            borderRadius: 12,
            border: '1px dashed #374151',
            textAlign: 'center',
            color: '#6b7280'
          }}>
            <p style={{ margin: 0 }}>No briefs in this package yet.</p>
            <p style={{ margin: '8px 0 0', fontSize: 13 }}>Process trends through the workflow and add them here.</p>
          </div>
        ) : (
          <div style={{ display: 'grid', gap: 16 }}>
            {pkg.briefs.map(brief => (
              <div key={brief.id} style={{
                backgroundColor: '#1e1e32',
                borderRadius: 12,
                padding: 24,
                border: '1px solid #2d2d44'
              }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 16 }}>
                  <div>
                    <h4 style={{ margin: '0 0 8px', fontSize: 16, fontWeight: '600', color: '#f3f4f6' }}>{brief.title}</h4>
                    <div style={{ display: 'flex', gap: 12, fontSize: 12, color: '#9ca3af' }}>
                      <span>Trend: <strong style={{ color: '#f3f4f6' }}>{brief.trend?.signal}</strong></span>
                      <span>Priority: <span style={{ color: '#ef4444' }}>{brief.priority}</span></span>
                      <span>Added: {brief.addedAt}</span>
                    </div>
                  </div>
                  <button
                    onClick={() => removeBriefFromPackage(brief.id)}
                    style={{
                      background: 'none',
                      border: '1px solid #374151',
                      borderRadius: 6,
                      padding: '6px 12px',
                      color: '#6b7280',
                      fontSize: 12,
                      cursor: 'pointer'
                    }}
                  >
                    Remove
                  </button>
                </div>

                {/* Category Tags */}
                <div style={{ display: 'flex', gap: 6, marginBottom: 16 }}>
                  {(brief.categories || []).map((cat, idx) => (
                    <span key={idx} style={{
                      padding: '3px 8px',
                      backgroundColor: '#3b82f620',
                      border: '1px solid #3b82f640',
                      borderRadius: 4,
                      fontSize: 10,
                      color: '#93c5fd'
                    }}>
                      {cat}
                    </span>
                  ))}
                </div>

                {/* Content Plan Summary */}
                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                  {brief.contentPlan?.map((item, idx) => (
                    <span key={idx} style={{
                      padding: '4px 10px',
                      backgroundColor: '#252540',
                      borderRadius: 4,
                      fontSize: 11,
                      color: '#d1d5db'
                    }}>
                      {item.type}: {item.title.substring(0, 30)}...
                    </span>
                  ))}
                </div>

                {/* Research indicator */}
                {brief.research?.length > 0 && (
                  <div style={{ marginTop: 12, paddingTop: 12, borderTop: '1px solid #2d2d44', display: 'flex', alignItems: 'center', gap: 8 }}>
                    <span style={{ fontSize: 11, color: '#f59e0b' }}>{'\uD83D\uDCCE'} {brief.research.length} research session{brief.research.length !== 1 ? 's' : ''} attached</span>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Package Actions */}
      {pkg.briefs.length > 0 && (
        <div style={{
          backgroundColor: '#1e1e32',
          borderRadius: 12,
          padding: 24,
          border: '1px solid #2d2d44'
        }}>
          <h3 style={{ margin: '0 0 16px', fontSize: 16, fontWeight: '600', color: '#f3f4f6' }}>Deliver Package</h3>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
            {/* Send to CSA */}
            <div
              onClick={sendPackageToCSA}
              style={{
                padding: 20,
                backgroundColor: '#252540',
                borderRadius: 8,
                cursor: 'pointer',
                border: '1px solid #374151',
                transition: 'all 0.2s'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.borderColor = '#10b981';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.borderColor = '#374151';
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 8 }}>
                <span style={{ fontSize: 24 }}>{'\u26A1'}</span>
                <h4 style={{ margin: 0, fontSize: 14, fontWeight: '600', color: '#f3f4f6' }}>Send to CSA</h4>
              </div>
              <p style={{ margin: 0, fontSize: 12, color: '#9ca3af', lineHeight: 1.5 }}>
                Send all {pkg.briefs.length} briefs through SEO API and into Content Scaling Agent as a batch.
              </p>
            </div>

            {/* Export Deliverable */}
            <div
              onClick={exportPackage}
              style={{
                padding: 20,
                backgroundColor: '#252540',
                borderRadius: 8,
                cursor: 'pointer',
                border: '1px solid #374151',
                transition: 'all 0.2s'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.borderColor = '#3b82f6';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.borderColor = '#374151';
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 8 }}>
                <span style={{ fontSize: 24 }}>{'\uD83D\uDCC4'}</span>
                <h4 style={{ margin: 0, fontSize: 14, fontWeight: '600', color: '#f3f4f6' }}>Export Deliverable</h4>
              </div>
              <p style={{ margin: 0, fontSize: 12, color: '#9ca3af', lineHeight: 1.5 }}>
                Export package as a formatted document for content team handoff.
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PackageDetailView;
